// ARCHX AI — Installed tooth libraries the design engine can use.
// `slug` matches engine/data/tooth_libraries/<slug>/ ; `name` is the display label.
// Keep in sync with the engine catalogs (re-run tools/import_tooth_library.py).
// 2026-06-17: pruned crystal, grin_design_7 (incomplete), zoo_* (non-dental), zz_* (dupes).
export const TOOTH_LIBRARIES = [
  { slug: 'g01_orlando_giraldo', name: 'G01 Orlando Giraldo' },
  { slug: 'g02_orlando_giraldo', name: 'G02 Orlando Giraldo' },
  { slug: 'grin_design_1', name: 'Grin Design 1' },
  { slug: 'grin_design_2', name: 'Grin Design 2' },
  { slug: 'grin_design_3', name: 'Grin Design 3' },
  { slug: 'grin_design_4', name: 'Grin Design 4' },
  { slug: 'grin_design_5', name: 'Grin Design 5' },
  { slug: 'grin_design_6', name: 'Grin Design 6' },
  { slug: 'grin_design_8', name: 'Grin Design 8' },
  { slug: 'grin_design_9', name: 'Grin Design 9' },
  { slug: 'zirkonzahn', name: 'Zirkonzahn' },
  { slug: 'zirkonzahn_phonares_bold_universal', name: 'Zirkonzahn Phonares Bold Universal' },
  { slug: 'zirkonzahn_z_10', name: 'Zirkonzahn Z10' },
  { slug: 'zirkonzahnaida', name: 'Zirkonzahn AIDA' },
  { slug: 'zirkonzahnareus', name: 'Zirkonzahn AREUS' },
  { slug: 'zirkonzahndemi', name: 'Zirkonzahn DEMI' },
  { slug: 'zirkonzahnhermes', name: 'Zirkonzahn HERMES' },
  { slug: 'zirkonzahnpaian', name: 'Zirkonzahn PAIAN' },
  { slug: 'zirkonzahnrheia', name: 'Zirkonzahn RHEIA' },
  { slug: 'zirkonzahnsao', name: 'Zirkonzahn SAO' },
  { slug: 'zirkonzahnseraphim', name: 'Zirkonzahn SERAPHIM' },
  { slug: 'zirkonzahnthalia', name: 'Zirkonzahn THALIA' },
  { slug: 'zirkonzahntriton', name: 'Zirkonzahn TRITON' },
];
